import React from 'react'
import ntimg from "../media/undraw_files-missing_ntwe.svg"

export default function Notfound() {
  return (
    <section className='notFoundWrap'>
        <img src={ntimg} alt="" />
        <h3>Oops! Page Not Found</h3>
        <p>The page you are looking for isn't found :(</p>
        <a href="/">Back to Home</a>

      
    </section>
  )
}
